import React from 'react'
import { authPost } from '../../../../infra/AuthFetcher';
import { createSdkUrl } from '../../../../providers/EnvContextProvider';
import './GenSdkButton.css';


export default function GenSdkButton({userIdToken, selectedTeamId, envPath, envName, isNew}) {
  const title = isNew ? `Generate ${envName} SDK Tokens` : `Renew ${envName} SDK Tokens`;

  const onResponse = (sdkCredz) => {    
    console.log('[sdkResponse: %s]', JSON.stringify(sdkCredz));
  }

  const onError = (errorData) => {
    console.error('Create SDK Error: %s',errorData);
  }

  const handleSdkTokens = async () => {    
    authPost(userIdToken, createSdkUrl, JSON.stringify({
      teamId: selectedTeamId,
      env: envPath
    })).then(onResponse)
    .catch(onError);
  }

  return (
    <div>
      <button className='sdkButton' onClick={handleSdkTokens}>{title}</button>
    </div>
  )
}
